import { FC } from 'react';
import { LinkProps } from 'antd/lib/typography/Link';
import { Typography } from 'antd';

const { Link } = Typography;

export const ILSTypographyLink: FC<LinkProps> = (props) => {
  return <Link {...props} />;
};
